// extracted by mini-css-extract-plugin
export default {"input-slider":"TimeSlider_input-slider__T+8kv"};